define(function() {
  var MAX_COLUMNS_IN_ROW = 12;

  function randomizeElements(params) {
    return params.$el.each(function() {
      var $elems = params.$el.find(params.itemSelector);
      var $sortedElements = $elems.sort(function(a, b) {
        return +a.dataset.size - +b.dataset.size;
      });

      var elementsWithoutGaps = [];
      var withoutGapsIndex = 0;

      var firstableElements = [].reduce.call(
        $sortedElements,
        function(acc, curr) {
          if (curr.dataset.first) {
            acc.push(curr);
          }
          return acc;
        },
        []
      );

      if (firstableElements.length > 1) {
        $sortedElements = $sortedElements.filter(function(idx, item) {
          return !item.dataset.first;
        });
      }

      for (var index = $sortedElements.length - 1; index >= 0; index -= 1) {
        elementsWithoutGaps.push([$sortedElements[index]]);
        elementsWithoutGaps[withoutGapsIndex].data = {};
        elementsWithoutGaps[
          withoutGapsIndex
        ].data.columnWeight = +$sortedElements[index].dataset.size;

        if ($sortedElements[index].dataset.first) {
          elementsWithoutGaps[withoutGapsIndex].data.shouldBeFirst = true;
        }

        for (var secondIndex = index - 1; secondIndex >= 0; secondIndex -= 1) {
          var currentValueInRow = elementsWithoutGaps[withoutGapsIndex].reduce(
            function(acc, curr) {
              return (acc += +curr.dataset.size);
            },
            0
          );
          var currentMinValue = MAX_COLUMNS_IN_ROW - currentValueInRow;
          var secondElementValue = +$sortedElements[secondIndex].dataset.size;
          var largerMaxValue = currentMinValue - secondElementValue < 0;

          if (currentMinValue === MAX_COLUMNS_IN_ROW || largerMaxValue) {
            continue;
          }

          if ($sortedElements[secondIndex].dataset.first) {
            elementsWithoutGaps[withoutGapsIndex].data.shouldBeFirst = true;
          }

          elementsWithoutGaps[
            withoutGapsIndex
          ].data.columnWeight += secondElementValue;
          elementsWithoutGaps[withoutGapsIndex].push(
            $sortedElements[secondIndex]
          );
          $sortedElements.splice(secondIndex, 1);
          index--;
        }

        $sortedElements.splice(index, 1);
        withoutGapsIndex++;
      }

      var firstRowArray =
        firstableElements.length > 1
          ? firstableElements
          : elementsWithoutGaps.filter(function(el) {
              return el.data.shouldBeFirst;
            });

      var filledArray = elementsWithoutGaps.filter(function(el) {
        return (
          el.data.columnWeight === MAX_COLUMNS_IN_ROW && !el.data.shouldBeFirst
        );
      });
      var partlyFilledArray = elementsWithoutGaps.filter(function(el) {
        return (
          el.data.columnWeight !== MAX_COLUMNS_IN_ROW && !el.data.shouldBeFirst
        );
      });

      // Avoid two large media in two last rows
      if (partlyFilledArray.length === 2) {
        var penultimateElement = partlyFilledArray[0][0];
        var lastElement = partlyFilledArray[1][0];

        if (
          penultimateElement.dataset.size === "8" &&
          lastElement.dataset.size === "8"
        ) {
          lastElement.classList.remove("mdl-cell--8-col");
          lastElement.classList.add("mdl-cell--4-col");
        }
      }

      var mixedArray = [];

      for (var i = 0; i < filledArray.length / 2; i++) {
        mixedArray.push(filledArray[filledArray.length - 1 - i]);
        mixedArray.push(filledArray[i]);
      }
      var flattenArray = firstRowArray
        .concat(mixedArray)
        .concat(partlyFilledArray)
        .reduce(function(acc, curr) {
          return acc.concat(curr);
        }, []);

      $elems.remove(params.itemSelector);

      for (var i = 0; i < flattenArray.length; i++) {
        params.$el.append(flattenArray[i]);
      }

      params.callback && params.callback();
    });
  }

  return { randomizeElements: randomizeElements };
});
